/**************************************************************************************************/
/*   File: /src/app/shared/models/user.ts                                                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 1st 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 01 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
export class User {
    /**
     * The name
     */
    name: string;
    /**
     * The user id
     */
    userId: number;
}